<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'PolicyServicing' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Policy Servicing</h2>
              <p class="listing-page-desc" style="text-transform: capitalize;">Submitted Requests</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
        <div class="col-md-12">
            <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
              <div class="row mb-4">
                <div class="col-12 ib-border-b">
                  <ul class="list-inline">
                    <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing">Endorsement Requests</h1></li>
                  </ul>
                </div>
                <div class="col-md-12 d-none d-md-block">
                  <table class="claim-listing" style="padding-top: 15px;">
                    <tbody>
                    <tr v-for="request in endorsementRequests" @click="EndorsementDetail(request.id)">
                      <td class="jbl-responsive-td data-img">
                        <div class="in-listing-img">
                          <img class="img-fluid" :src="require('@/assets/images/req-list.png')" />
                        </div>
                      </td>
                      <td class="jbl-responsive-td" >
                        <div class="jbl-flex-td">
                          <div class="jbl-date-td">Request Submitted</div>
                          <div class="jbl-date-td"><small class="text-capitalize endorsement-desc">Policy Request Submitted for {{ request.endorsement_type.toLowerCase().split("_").join(" ") }}</small></div>
                        </div>
                      </td>
                      <td class="jbl-responsive-td">
                        <div class="jbl-flex-td">
                          <div class="jbl-date-td jbl-date-heading">{{ formatDate(request.created_at) }}</div>
                          <!-- <div class="jbl-date-td">{{ formatDate(request.created_at) }}</div> -->
                        </div>
                      </td>
                      <td class="jbl-responsive-td in-w-60">
                        <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <h2 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center;" v-if="endorsementRequests.length === 0">No Request Found</h2>
                </div>
              </div>
            </div>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '@/components/Loading/Loading'
import moment from "moment";
import _ from 'lodash';

export default {
  name: 'ViewPolicy',
  components: {
    loading
  },
  data() {
    return {
      showLoader: true,
      endorsementRequests: {},
      quotation_id: this.$route.params.id
    };
  },
  created: function () {
    const self = this;
    self.getEndorsements();
  },
  computed: {

    date() {
      return moment().format('DD-MM-YYYY');
    }
  },
  methods: {

    priceFormatter(price) {
      return new Intl.NumberFormat('en-PK').format(price);
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
    },
    async getEndorsements(id) {
      var self = this;
      self.showLoader = true;
      await axios.get('customer/endorsement/requests?customer_quotation_id='+ self.quotation_id).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.endorsementRequests = resp.data.requests;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    EndorsementDetail(id){
      let self = this;
      self.$router.push({ name: 'EndorsementDetail', params: {id: id } });
    }
  }
};
</script>

<style scoped>
.data-row p {
  color :#5b6770;
}
table > tbody > tr, .data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  border: solid 1px #dedada;
  background-color: #ffffff;
}
.data-row .action-area {
  text-align: right;
}
.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}
.data-row .claim-row-sub-heading {
  color: #a9adaf;
}
.data-row .claim-row-sub-desc {
  color: #5b6770;
}
.data-row .status-danger {
  background-color: rgba(30, 203, 16, 0.09);
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  color: #1ecb10;
  letter-spacing: normal;
}
.data-row .status {
  margin: 10px 61.3px 10px 52px;
  padding: 6px 24px;
  border-radius: 6px;
  font-family: "Futura PT";
}
.data-row .claim-row-data {
  font-family: "Futura PT";
  font-size: 17px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 8px;
  letter-spacing: normal;
  text-align: left;
}
.data-row .claim-row-heading {
  font-family: "Futura PT";
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
.in-listing-img {
  width: 79px;
  height: 66px;
  /* background-color: transparent; */
  /* border-radius: 11px; */
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.in-listing-img img{
  width: 100% !important;
  max-width: 70px !important;
  max-height: 60px !important;
  height: auto !important;
}

.position-relative-box {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid gainsboro;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: absolute;
  bottom: -10px;
  right: -10px;
}
.position-relative-box img{
  width: 100% !important;
  max-width: 23px !important;
  height: auto !important;
}
table.claim-listing {
  width: 100%;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-collapse: separate;
  border-spacing: 0 10px;
}
table.claim-listing td {
  height: 100px !important;
  vertical-align: middle;
  text-align: center;
  position: relative;
}
@media (max-width:668px) {
  table.claim-listing td:not(:first-child) {
    height: 60px !important;
  }
  table.claim-listing tbody td:first-child{
    height: auto !important;
  }
}
table.claim-listing td:last-child:after {
  content: none;
}
table.claim-listing tbody td {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
@media (min-width:669px) {
  table.claim-listing tbody td:first-child {
    border-left: 1px solid #eee;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    width: 112px;
  }
  table.claim-listing tbody td:last-child {
    border-right: 1px solid #eee;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  table.claim-listing tbody tr {
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  }
}
.jbl-table-heading {
  font-family: "Avenir Medium";
  font-weight: 500;
  text-align: left !important;
  font-size: 19px;
  color: #5b6770;
}

.jbl-table-heading span {
  font-weight: normal !important;
  font-size: 10px !important;
  font-weight: 500 !important;
  color: #ef7c94 !important;
}
.jbl-table-heading small {
  font-weight: normal !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #ef7c94 !important;
}
.jbl-date-td {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
}
.jbl-date-td  small.endorsement-desc{
  color: var(--text-color) !important;
  font-size: 14px !important;
}
.jbl-date-heading {
  color: #ef7c94 !important;
  font-family: "Avenir Book";
  font-size: 13px;
  text-align: left;
}
table.claim-listing .fa-chevron-right {
  padding-right: 2rem;
  color: #5b6770;
}
.jbl-flex-td {
  display: flex;
  flex-direction: column;
}
@media (min-width:668px) and (max-width:992px) {
  .jbl-table-heading {
    font-size: 14px;
  }
  .jbl-date-td {
    font-family:"Futura PT Medium";
    font-size: 12px;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 1rem;
    color: #5b6770;
  }
}
.d2c-main-classes {
  background-color: #def3f7;
  border-radius: 31px;
  max-width: fit-content;
  margin: 1px 0 30px;
}
.d2c-class-btn {
  display: inline-block;
  margin-bottom: 0;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 61px;
  margin: 0 0 1px;
  border-radius: 31px;
  background-color: #def3f7;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: 500;
  line-height: 1.38;
  color: #4c505d;
  transition: all .3s ease-in;
}
@media(max-width:550px){
  .d2c-class-btn{
    padding: 6px 22px !important;
    width: max-content !important;
    font-size: 12px !important;
  }
}
.d2c-class-btn:hover {
  background-color: #049cbd;
  color: white;
}
.d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
  outline: none !important;
  background-color: #049cbd;
  color: white;
}
.nex-Page-Link .fa-chevron-right {
  color: #aeccd6 !important;
  font-weight: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PolicyServicing/EndorsementRequests.vue